import React from 'react'
// import PropTypes from 'prop-types'

import { MainTitle, TextContent } from '../../../../components/Shared';
import {
  StyledWrapper,
} from './ApiIntroduction.styled';

const ApiIntroduction = props => {
  return (
    <StyledWrapper>
      <MainTitle>API Introduction</MainTitle>
      <TextContent>
        BK Traffic provides a simple and powerful REST API to integrate traffic status, routing,... intro your business or application.
      </TextContent>

      <TextContent>
        This API reference provides information on available endpoints and how to interact with it.
      </TextContent>
    </StyledWrapper>
  )
}

ApiIntroduction.propTypes = {

}

export default ApiIntroduction
